import BetModel from "../../../vendor_core/core/src/model/BetModel";
import GameModel from "../../../vendor_core/core/src/model/GameModel";
import { ICondition } from "../../../vendor_core/core/src/states/State";
import BURSpinModel from "../models/BURSpinModel";

export class BURHasSmallWinCondition implements ICondition {
    public check(): boolean {
        const win = this.getWin();
        if (win === 0) {
            return false;
        }
        return this.hasSmallWin(win);
    }

    private hasSmallWin(win: number): boolean {
        return (
            this.getWinMultiplier(win) <
            (GameModel.gameConfig as any).bigWinRatioLevels[0]
        );
    }

    private getWin() {
        return BURSpinModel.cascades_total_win;
    }

    private getWinMultiplier(win: number) {
        return win / BetModel.totalBet;
    }
}
